import {createFileRoute, useNavigate} from '@tanstack/react-router';
import {useEffect} from 'react';

import {useFeatureFlags} from '~utils/featureFlags';
import {Route as RouteEnum} from '~utils/routeUtil';

import {BaseLayout} from '~components/_layout/BaseLayout';
import {Statistics, StatisticsTabName} from '~components/statistics/Statistics';
import {ModelProvider} from 'src/contexts/ModelProvider';

export const Route = createFileRoute('/model/statistics/label-noise')({
  component: ModelStatisticsLabelNoisePage,
});

function ModelStatisticsLabelNoisePage(): JSX.Element | null {
  const {toggleEnableInsights} = useFeatureFlags();
  const navigate = useNavigate();

  useEffect(() => {
    if (!toggleEnableInsights) {
      navigate({to: RouteEnum.notFound as any});
    }
  }, [toggleEnableInsights, navigate]);

  if (!toggleEnableInsights) {
    return null;
  }

  return (
    <ModelProvider mode='model-pages'>
      <BaseLayout showBackButton>
        <Statistics tabName={StatisticsTabName.LabelNoise} />
      </BaseLayout>
    </ModelProvider>
  );
}
